import { render, staticRenderFns } from "./NFT.vue?vue&type=template&id=51621a86&"
import script from "./NFT.vue?vue&type=script&lang=js&"
export * from "./NFT.vue?vue&type=script&lang=js&"
import style0 from "./NFT.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports